import React, { useState } from 'react';
import { Button, FormControl, Select, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import '../healthoverview.css';
import AddDataModal from './AddDataModal';
import { getDevices, getUserDevices } from '../../../utils/api';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
const ChartControls = ({
  period,
  handlePeriodChange,
  showComparison,
  toggleComparison,
  dataType,
  userId,
  selectedRecipient,
  device,
  handleDeviceChange,
}) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };
  const { data: apiResponse } = useQuery({
    queryKey: ['devices', userId, selectedRecipient],
    queryFn: () => (selectedRecipient ? getUserDevices({ userId, selectedRecipient }) : getDevices({ userId })),
    enabled: dataType === 'Distance' || dataType === 'Steps',
  });
  const devices = apiResponse?.data || [];

  return (
    <>
      <div className="controls-container" style={{ width: '100%', justifyContent: 'space-between', marginTop: '10px' }}>
        <div className="filter-controls">
          <Button
            variant="outlined"
            className={`compare-button ${showComparison ? 'active-compare' : ''}`}
            size="small"
            onClick={toggleComparison}
            style={{
              backgroundColor: showComparison ? '#f0f9f6' : 'white',
              borderColor: showComparison ? '#3b9b8f' : '#e0e0e0',
              color: showComparison ? '#3b9b8f' : 'rgba(0, 0, 0, 0.87)',
            }}
          >
            {t('compare')}
          </Button>
          <FormControl className="period-select" size="small">
            <Select value={period} onChange={handlePeriodChange} style={{ borderRadius: '50px' }}>
              <MenuItem value="monthly">{t('monthly')}</MenuItem>
              <MenuItem value="weekly">{t('weekly')}</MenuItem>
              <MenuItem value="daily">{t('today')}</MenuItem>
            </Select>
          </FormControl>
        </div>

        {dataType && dataType !== 'Gait Speed' && dataType !== 'Glucose' && (
          <>
            {dataType === 'Distance' || dataType === 'Steps' ? (
              <FormControl className="period-select" size="small">
                <Select
                  value={device?._id || 'Average From All Devices'}
                  onChange={(e) =>
                    handleDeviceChange({
                      _id: e.target.value,
                      name:
                        e.target.value === 'Average From All Devices'
                          ? 'Average From All Devices'
                          : devices.find((d) => d._id === e.target.value)?.name,
                    })
                  }
                  style={{ borderRadius: '50px' }}
                >
                  <MenuItem value="Average From All Devices">{t('averageFromAllDevices')}</MenuItem>
                  {devices.map((device) => {
                    return (
                      <MenuItem key={device._id} value={device._id}>
                        {device.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            ) : (
              <Button
                variant="contained"
                className="add-button"
                startIcon={<AddIcon />}
                size="small"
                onClick={handleOpenModal}
              >
                {t('addManually')}
              </Button>
            )}
          </>
        )}
      </div>

      <AddDataModal open={modalOpen} handleClose={handleCloseModal} dataType={dataType} userId={userId} />
    </>
  );
};

export default ChartControls;
